import { ListItemText, Typography } from '@mui/material';
import {
  Highlight,
  RelatedAvailableOption,
} from '../../../../models/related-tickets/types';
import * as Styled from './styled';

export const RenderOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: RelatedAvailableOption
) => (
  <li {...props}>
    <ListItemText
      primary={
        <Typography variant="body1" component={'div'}>
          <OptionPart text={option.title.value} highlight={option.title.highlight} />
        </Typography>
      }
      secondary={
        <Typography variant="body2" component={'div'}>
          <OptionPart
            text={option.subtitle.value}
            highlight={option.subtitle.highlight}
          />
        </Typography>
      }
    />
  </li>
);

const Highlighted = ({ part }: { part: string }) => (
  <Styled.Highlighted color="primary">{part}</Styled.Highlighted>
);

export const OptionPart = ({
  text,
  highlight,
}: {
  text: string;
  highlight?: Highlight[];
}) => {
  if (!highlight?.length) return text;

  const highlightData = (highlight as Highlight[]).sort((a, b) => a.from - b.from);

  let startPos = 0;
  const highlightedArr = highlightData.reduce(
    (acc, { from, to }, index, arr) => {
      if (from !== startPos) acc.push(text.substring(startPos, from));

      acc.push(<Highlighted key={`${from}-${to}`} part={text.substring(from, to + 1)} />);

      startPos = to + 1;

      if (index === arr.length - 1 && text.length > startPos)
        acc.push(text.substring(startPos));

      return acc;
    },
    [] as (JSX.Element | string)[]
  );

  return highlightedArr;
};
